import { jsx } from "panel";
import { FormattedMessageEl } from "common/components/formatted-message";
import { TooltipEl } from "common/components/tooltip";
export function template() {
  const { open } = this.state;
  return /* @__PURE__ */ jsx("div", {
    sel: ".code-tip"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".code-tip-wrapper"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".code-tip-btn",
    class: { open },
    on: { click: this.helpers.handleCodeTipBtnClick }
  }, open ? /* @__PURE__ */ jsx(TooltipEl, {
    attrs: { "always-show": true, offset: 10 }
  }, /* @__PURE__ */ jsx(FormattedMessageEl, {
    sel: ".code-tip-src",
    attrs: { parts: this.helpers.getJadeParts() }
  })) : null)), /* @__PURE__ */ jsx("slot", null));
}
